/**
 * Created by chenzheyu on 2017/6/23.
 */
/* eslint-disable no-undex */
import Vue from 'vue'
import InitData from '../store/configure'
import coordtransform from 'coordtransform'
import JSONBig from 'json-bigint-xk'
// import wx from 'weixin-js-sdk'
// import AMap from 'AMap'
// import Toucth from '../assets/js/method'

// callback(data.body)

export default {
  getWxAppId (params, callback) { // 获取微信appId
    params = Vue.prototype.$utils.objKeySort('/passenger/api/v1/wechat', params)
    //params.terminal = 'wechat_boss'
    let url = InitData.serverUrl + '/wechat'
    Vue.http.get(url, {params}, {emulateJSON: true}).then(
      data => {
        callback(JSONBig.parse(data.bodyText))
      }
    )
  },
  getjsApiTicket (params, callback) { // 获取微信配置信息
    params = Vue.prototype.$utils.objKeySort('/passenger/api/v1/jsApiTicket', params)
    //params.terminal = 'wechat_boss'
    let url = '/v1/jsApiTicket'
    Vue.http.get(url, {params}, {emulateJSON: true}).then(
      data => {
        callback(JSONBig.parse(data.bodyText))
      }
    )
  },
  getNearDrivers (params, callback) { // 获取附近司机
    params = Vue.prototype.$utils.objKeySort('/passenger/api/v1/getNearDrivers', params)
    //params.terminal = 'wechat_boss'
    let url = '/v1/getNearDrivers'
    Vue.http.get(url, {params}, {emulateJSON: true}).then(
      data => {
        callback(JSONBig.parse(data.bodyText))
      }
    )
  },
  getInitInfo (params, callback) { // 获取初始化数据
    // Vue.prototype.$utils.paramsAsync()
    params = Vue.prototype.$utils.objKeySort('/passenger/api/v1/company', params)
    //params.terminal = 'wechat_boss'
    Vue.http.get('/v1/company', {params}).then((data) => {
      callback(JSONBig.parse(JSON.stringify(data.body)))
    })
  },
  getBusiness (params, callback) { // 根据 公司主业务获取子业务类型
    // Vue.prototype.$utils.paramsAsync()
    params = Vue.prototype.$utils.objKeySort('/passenger/api/v1/getBusiness', params)
    //params.terminal = 'wechat_boss'
    if (params.company_id) {
      Vue.http.get('/v1/getBusiness', {params}).then((data) => {
        callback(JSONBig.parse(data.bodyText))
      })
    }
  },
  getNotice (params, callback) { // 获取 客户消息
    params = Vue.prototype.$utils.objKeySort('/passenger/api/v1/notice', params)
    //params.terminal = 'wechat_boss'
    Vue.http.get('/v1/notice', {params}, {emulateJSON: true}).then((data) => {
      callback(JSONBig.parse(JSON.stringify(data.body)))
    })
  },
  positioningApi (obj, callback) { // 获取定位
    // let that = this
    let url = ''
    let params = {
      key: window.configure.amapKey
    }
    let point = {
      lng: null,
      lat: null,
      country: null, // 国籍
      detailedAddress: null, // 详细地址
      ad_code: null, // 地址编码
      city_code: null // 城市编码
    }
    // let chooseBestPoi = function (pois) {
    //   if (pois.length > 0) {
    //     var best = null
    //
    //     if (pois.length > 0) {
    //       best = pois[0]
    //
    //       for (var i = 0; i < pois.length; i++) {
    //         if (parseFloat(best.distance) > parseFloat(pois[i].distance)) {
    //           best = pois[i]
    //         }
    //       }
    //     }
    //     return best.name
    //   }
    //   return {}
    // }
    /**
     * 显示定位数据
     * @param {obj} position
     */
    function showPosition (position) { // 成功处理
      // alert('浏览器定位成功：' + JSON.stringify(position))
      console.log('浏览器定位成功处理', position)
      let pos = coordtransform.wgs84togcj02(position.coords.longitude, position.coords.latitude)
      url = '/v3/geocode/regeo?'
      params = {
        key: window.configure.amapKey,
        location: pos[0].toFixed(6) + ',' + pos[1].toFixed(6),
        extensions: 'all',
        output: 'JSON',
        // terminal: 'wechat_boss'
      }
      Vue.http.get(url, {params: params}, {emulateJSON: true}).then((data) => {
        let Data = data.body.regeocode
        // lng，lat
        let lng = null
        let lat = null
        let location = null
        if (Data.addressComponent && Data.addressComponent.streetNumber && Data.addressComponent.streetNumber.location && JSON.stringify(Data.addressComponent.streetNumber.location) !== '' && JSON.stringify(Data.addressComponent.streetNumber.location) !== '') {
          lng = Data.addressComponent.streetNumber.location.split(',')[0]
          lat = Data.addressComponent.streetNumber.location.split(',')[1]
        } else {
          if (Data.pois && Data.pois.length > 0) {
            location = Data.pois[0]
            // for (let i = 0; i <= Data.pois.length; i++) {
            //   if (parseFloat(location.distance) > parseFloat(Data.pois[i].distance)) {
            //     location = Data.pois[i]
            //   }
            // }
            lng = location.location.split(',')[0]
            lat = location.location.split(',')[1]
          } else {
            lng = pos[0].toFixed(6)
            lat = pos[1].toFixed(6)
          }
        }
        // city
        let city = null
        if (Data.addressComponent.city && JSON.stringify(Data.addressComponent.city) !== '[]' && JSON.stringify(Data.addressComponent.city) !== '') {
          city = Data.addressComponent.city
        } else if (Data.formatted_address && Data.formatted_address !== '' && Data.formatted_address.indexOf('市') > 0) {
          city = Data.formatted_address.substring(Data.formatted_address.indexOf('省') + 1, Data.formatted_address.indexOf('市') + 1)
        } else if (Data.addressComponent.district) { // 地级市
          city = Data.addressComponent.district
        }
        point.lng = lng
        point.lat = lat
        point.city = city
        point.name = Data.formatted_address
        point.ad_code = Data.addressComponent.adcode ? Data.addressComponent.adcode : null
        point.city_code = Data.addressComponent.citycode ? Data.addressComponent.citycode : null
        point.detailedAddress = Data.formatted_address ? Data.formatted_address : ''
        console.log('initdata.js-getlocation-position', point)
        callback(point)
      })
    };

    /**
     * 高德定位
     */
    function gaodeLocation () {
      console.log('高德IP定位')
      // let url = '/v3/ip'
      let url = '/v1/amap/geo/ip'
      let params = {
        key: window.configure.amapKey,
        app_key: InitData.appKey,
        // terminal: 'wechat_boss'
      }
      Vue.http.get(url, {params: params}, {emulateJSON: true}).then((data) => {
        let dataBody = data.body.geo
        // alert('高德地图获取位置信息' + JSON.stringify(data))
        if (dataBody && Number(dataBody.status) === 1) {
          let Data = dataBody
          let addr = (Data.province ? Data.province : null) + (Data.city ? Data.city : null)
          let url1 = '/v3/geocode/geo'
          let params1 = {
            key: window.configure.amapKey,
            address: addr,
            city: Data.city.replace('市', ''),
            // terminal: 'wechat_boss'
          }
          Vue.http.get(url1, {params: params1}, {emulateJSON: true}).then((data) => {
            let info = data.body
            if (info.geocodes[0] && info.geocodes[0].location && info.geocodes[0].location !== '') {
              let res = info.geocodes[0].location.split(',')
              point.lng = res[0]
              point.lat = res[1]
              point.city = info.geocodes[0].city ? info.geocodes[0].city : ''
              point.name = info.geocodes[0].formatted_address ? info.geocodes[0].formatted_address : ''
              point.ad_code = info.geocodes[0].adcode ? info.geocodes[0].adcode : null
              point.city_code = info.geocodes[0].citycode ? info.geocodes[0].citycode : null
              point.detailedAddress = info.geocodes[0].formatted_address ? info.geocodes[0].formatted_address : ''
              callback(point)
            } else {
              callback('定位失败，请检查是否已开启定位')
            }
            // 9.14 新加
            // let regeoUrl = '/v3/geocode/regeo?'
            // params = {
            //   key: window.configure.amapKey,
            //   location: res[0] + ',' + res[1],
            //   extensions: 'all',
            //   output: 'JSON'
            // }
            // Vue.http.get(regeoUrl, {params: params}).then((data) => {
            //   console.log('高德逆地址解析', data)
            //   let regeoData = data.body.regeocode
            //   point.lng = regeoData.addressComponent.streetNumber.location.split(',')[0]
            //   point.lat = regeoData.addressComponent.streetNumber.location.split(',')[1]
            //   point.city = regeoData.addressComponent.city
            //   point.name = chooseBestPoi(regeoData.pois) || '地址逆解析失败'
            //   point.ad_code = regeoData.addressComponent.adcode
            //   point.city_code = regeoData.addressComponent.citycode
            //   point.detailedAddress = regeoData.formatted_address
            //   callback(point)
            // })
          })
        } else {
          callback('定位失败，请检查是否已开启定位')
        }
      })
    };

    function getLocation () { // 获取原生定位
      if (navigator.geolocation) {
        console.log('支持地理定位', navigator.geolocation)
        navigator.geolocation.getCurrentPosition(showPosition, gaodeLocation, {timeout: 3000})
      } else {
        console.log('不支持地理定位')
        gaodeLocation()
        // showPosition({coords: {longitude: 103.863555, latitude: 30.685689}})
      }
    }

    getLocation()
  },
  allOrder (obj, callback) { // 查询所有订单
    var params = {
      'app_key': InitData.appKey,
      'serviceType': obj.serviceType,
      'passengerId': obj.passengerId,
      'page': obj.page,
      'rows': obj.rows
    }
    Vue.http.get(InitData.weixinUrl + '/v5/passenger/getOrders', {params}, {emulateJSON: true}).then((data) => {
      callback(JSONBig.parse(data.bodyText))
    })
  },
  unfilledOrder (params, callback) { // 查询未完成订单
    params = Vue.prototype.$utils.objKeySort('/passenger/api/v1/runingOrders', params)
    //params.terminal = 'wechat_boss'
    Vue.http.get('/v1/runingOrders', {params}, {emulateJSON: true}).then((data) => {
      callback(JSONBig.parse(data.bodyText))
    })
  },

  /**
   * 根据业务查询优惠券
   * @param {*} params
   * @param {*} callback
   */
  getCouponType (params, callback) {
    params = Vue.prototype.$utils.objKeySort('/api/v1/coupons', params)
    Vue.http.get('/api/v1/coupons', {params}).then((data) => {
      callback(JSONBig.parse(data.bodyText))
    })
  },

  getBudgetPrice (params, callback) { // 预算费用
    params = Vue.prototype.$utils.objKeySort('/passenger/api/v1/budget', params)
    Vue.http.post('/v1/budget', params, {emulateJSON: true}).then(data => {
      callback(JSONBig.parse(data.bodyText))
    })
  },

  systemConfig (params, callback) { // 获取套餐权限
    params = Vue.prototype.$utils.objKeySort('/passenger/api/v1/systemConfig', params)
    //params.terminal = 'wechat_boss'
    Vue.http.get('/v1/systemConfig', {params}).then(data => {
      callback(JSONBig.parse(data.bodyText))
    })
  },

  postCreateOrder (params, callback) { // 根据 业务子类型  下单
    params = Vue.prototype.$utils.objKeySort('/passenger/api/v1/createOrder', params)
    //params.terminal = 'wechat_boss'
    Vue.http.post('/v1/createOrder', params, {emulateJSON: true}).then((data) => {
      callback(JSONBig.parse(data.bodyText))
    })
  },
  getOrderFindOne (params, callback) { // 根据 id 查询订单
    params = Vue.prototype.$utils.objKeySort('/passenger/api/v1/orderFindOne', params)
    //params.terminal = 'wechat_boss'
    Vue.http.get('/v1/orderFindOne', {params}, {emulateJSON: true}).then((data) => {
      callback(JSONBig.parse(data.bodyText))
    })
  },
  putFinishOrder (params, callback) { // 根据 id 结算支付订单
    console.log(3)
    params = Vue.prototype.$utils.objKeySort('/api/v1/finishOrder', params)
    //params.terminal = 'wechat_boss'
    Vue.http.put('/api/v1/finishOrder', params, {emulateJSON: true}).then((data) => {
      callback(JSONBig.parse(data.bodyText))
    })
  },
  putCancelOrder (params, callback) { // 取消订单
    params = Vue.prototype.$utils.objKeySort('/api/v1/cancelOrder', params)
    //params.terminal = 'wechat_boss'
    Vue.http.put('/v1/cancelOrder', params, {emulateJSON: true}).then((data) => {
      callback(JSONBig.parse(data.bodyText))
    })
  },
  getTags (params, callback) { // 获取 评价 标签集合
    params = Vue.prototype.$utils.objKeySort('/passenger/api/v1/tags', params)
    //params.terminal = 'wechat_boss'
    Vue.http.get('/v1/tags', {params}, {emulateJSON: true}).then((data) => {
      callback(JSONBig.parse(data.bodyText))
    })
  },
  putRateOrder (params, callback) { // 订单评价
    params = Vue.prototype.$utils.objKeySort('/passenger/api/v1/rateOrder', params)
    //params.terminal = 'wechat_boss'
    Vue.http.put('/v1/rateOrder', params, {emulateJSON: true}).then((data) => {
      callback(JSONBig.parse(data.bodyText))
    })
  },

  /**
   * 路径规划
   * @param {*} obj
   * @param {*} callback
   */
  routePlanning (obj, callback) {
    let params = {
      key: window.configure.amapKey,
      strategy: 10, // 策略: 距离优先，不考虑路况，仅走距离最短的路线  // 统一策略
      origin: obj.originLng + ',' + obj.originLat, // 出发地 经维度
      destination: obj.destinationLng + ',' + obj.destinationLat, // 目的地 经纬度
      output: 'json'
    }
    let url = '/v3/direction/driving'
    Vue.http.jsonp(url, {params: params}).then((data) => {
      callback(JSONBig.parse(data.bodyText))
    })
  },
  accredit (obj, callback) {
    /**
     * 判断是否来自微信
     */
    function isFromWx () {
      var ua = navigator.userAgent.toLowerCase()
      if (ua.match(/MicroMessenger/i) && ua.match(/MicroMessenger/i)[0] === 'micromessenger') {
        return true
      }
      return false
    }

    /**
     * 获取查询参数
     * @param name
     * @returns {null}
     */
    function getQueryString () {
      var args = {}
      var query = location.search.substring(1)
      var pairs = query.split('&')
      for (var i = 0; i < pairs.length; i++) {
        var pos = pairs[i].indexOf('=')
        if (Number(pos) === -1) {
          continue
        }
        var argname = pairs[i].substring(0, pos)
        var value = pairs[i].substring(pos + 1)
        value = decodeURIComponent(value)
        args[argname] = value
      }
      return args
    }

    // 判断获取code的js
    var _obj = getQueryString()
    if (!isFromWx()) {
      callback({wxState: false})
      return false
    }
    if (isFromWx() && !_obj.code) {
      var baseURL = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + InitData.WXappId + '&redirect_uri=' + encodeURIComponent(location.href) + '&response_type=code&scope=snsapi_base&state=null#wechat_redirect'
      window.location.replace(baseURL)
    } else {
      callback({wxState: true, code: _obj.code})
    }
  },
  urlEnabled (obj, callback) {
    Vue.http.get(obj.url).then(
      (data) => {
        callback(true)
      },
      (data) => {
        callback(false)
      })
  },
  googleMapSite (obj, callback) {
    var params = {
      'app_key': InitData.appKey,
      'name': obj.query
    }
    var url = window.configure.googleUrl + '/v5/zhuanche/queryAddressByGoogle'
    Vue.http.get(url, {params: params}, {emulateJSON: true}).then((data) => {
      if (data.body.errorMsg === '请求成功') {
        var result = []
        if (data.body.data.length > 0) {
          for (var i = 0; i < data.body.data.length; i++) {
            var obj = data.body.data[i]
            result.push({
              name: obj.name,
              detailedAddress: obj.formatted_address,
              lng: obj.lng,
              lat: obj.lat
            })
          }
        } else {
          result = []
        }
        callback(result)
      }
    })
  },
  amapMapSite (obj, callback) {
    var url = 'https://restapi.amap.com/v3/place/text'
    var params = {
      keywords: obj.query,
      city: obj.city || null,
      key: window.configure.amapKey,
      output: 'JSON',
      extensions: 'all'
    }
    Vue.http.jsonp(url, {params: params}).then((response) => {
      if (response.body.status === '1') {
        var result = []
        let Data = response.body.pois
        if (Data.length > 0) {
          Data.forEach((opt) => {
            result.push({
              citycode: opt.citycode,
              adcode: opt.adcode,
              name: opt.name,
              city: opt.cityname,
              detailedAddress: opt.cityname + (opt.address || ''),
              lng: opt.location.split(',')[0],
              lat: opt.location.split(',')[1]
            })
          })
        }
        callback(result)
      }
    })
  },
  googleForLongitude (obj, callback) { // Google地址解析
    var url = window.configure.googleUrl + '/v5/zhuanche/addressInfoByLatLngForGoogle'
    var params = {
      'app_key': InitData.appKey,
      'lat': obj.lat,
      'lng': obj.lng
    }
    Vue.http.get(url, {params: params}, {emulateJSON: true}).then((data) => {
      callback(JSONBig.parse(data.bodyText))
    })
  },
  baiduForLongitude (obj, callback) {  // 百度地址解析
    var url = 'https://api.map.baidu.com/geocoder/v2/?&output=json&pois=1'
    var params = {
      ak: InitData.baiduKey,
      coordtype: 'wgs84ll',
      ret_coordtype: 'gcj02ll',
      location: obj.lat + ',' + obj.lng
      // location: 30.383442155594476 + ',' + 103.8060055926331
    }
    Vue.http.jsonp(url, {params: params}).then((data) => {
      var chooseBestPoi = function (pois) {
        var best = null

        if (pois.length > 0) {
          best = pois[0]

          for (var i = 0; i < pois.length; i++) {
            if (parseFloat(best.distance) > parseFloat(pois[i].distance)) {
              best = pois[i]
            }
          }
        }

        return best
      }
      let sematicDescription = data.body.result.sematic_description
      var add = null
      var obj = null
      if (data.body.result.pois.length > 0) {
        add = chooseBestPoi(data.body.result.pois)
        if (Number(add.distance) < 300) {
          obj = {
            name: sematicDescription,
            city: data.body.result.addressComponent.city,
            detailedAddress: data.body.result.addressComponent.province + data.body.result.addressComponent.city + data.body.result.addressComponent.district + add.addr + add.name,
            lng: add.point.x,
            lat: add.point.y
          }
        } else {
          add = data.body.result.addressComponent
          obj = {
            name: sematicDescription,
            city: add.city,
            detailedAddress: add.province + add.city + add.district + add.street + add.street_number,
            lng: data.body.result.location.lng,
            lat: data.body.result.location.lat
          }
        }
      } else {
        add = data.body.result.addressComponent
        obj = {
          name: sematicDescription,
          city: add.city,
          detailedAddress: add.province + add.city + add.district + add.street + add.street_number,
          lng: data.body.result.location.lng,
          lat: data.body.result.location.lat
        }
      }
      callback(obj)
    })
  },
  countLine (obj, callback) {
    var url = 'https://api.map.baidu.com/direction/v1/?mode=driving&output=json'
    var params = {
      ak: InitData.baiduKey,
      origin: obj.origin,
      destination_region: obj.destination_region,
      origin_region: obj.origin_region,
      destination: obj.destination
    }
    if (obj.waypoints) {
      params['waypoints'] = obj.waypoints
    }
    Vue.http.jsonp(url, {params: params}).then((data) => {
      callback(JSONBig.parse(data.bodyText))
    })
  },
  checkWX (obj, callback) {
    /**
     * 判断是否来自微信
     */
    function isFromWx () {
      var ua = navigator.userAgent.toLowerCase()
      if (ua.match(/MicroMessenger/i) && ua.match(/MicroMessenger/i)[0] === 'micromessenger') {
        return true
      }
      return false
    }

    callback(isFromWx())
  }
}



// WEBPACK FOOTER //
// ./src/api/initdata.js